import type { PropsWithChildren } from "react";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { FilterDialog, FilterList } from "@tenant/hotels";
import defaultStyles from "./Filters.module.scss";

export const Filters = ({ children }: PropsWithChildren) => {
  const styles = useHotelsStyles(CoreHotelsComponent.Filters, defaultStyles);
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.Filters);

  return (
    <div className={block}>
      {children}
      <FilterDialog />
      <FilterList className={cn("filter-list")} />
    </div>
  );
};
